import { createTheme, Theme } from "@mui/material/styles";
import { SenecEkpTheme } from "src/styles/ekp-theme/senecEkpTheme";

declare module "@mui/material/styles" {
    interface TypographyVariants {
        buttonSmall: React.CSSProperties;
    }

    // allow configuration using `createTheme`
    interface TypographyVariantsOptions {
        buttonSmall?: React.CSSProperties;
    }
}

// Update the Typography's variant prop options
declare module "@mui/material/Typography" {
    interface TypographyPropsVariantOverrides {
        buttonSmall: true;
    }
}

export const createTypographyTheme = (baseTheme: Theme, paletteTheme: SenecEkpTheme) => {
    return createTheme(paletteTheme, {
        typography: {
            h1: {
                fontFamily: "Mark Pro, sans-serif",
                fontSize: 36,
                fontWeight: 500,
                lineHeight: "140%",
            },
            h2: {
                fontFamily: "Mark Pro, sans-serif",
                fontSize: 24,
                fontWeight: 500,
                lineHeight: "125%",
            },
            h3: {
                fontFamily: "Mark Pro, sans-serif",
                fontSize: 18,
                fontWeight: 500,
                lineHeight: "140%",
            },
            h4: {
                fontFamily: "Mark Pro, sans-serif",
                fontWeight: 500,
                lineHeight: "150%",
                fontSize: 16,
            },
            body1: {
                fontFamily: "EnBW DIN Pro, sans-serif",
                fontSize: 16,
                fontWeight: 400,
                lineHeight: "150%",
                whiteSpace: "pre-wrap",
            },
            body2: {
                fontFamily: "EnBW DIN Pro, sans-serif",
                fontSize: 14,
                fontWeight: 400,
                lineHeight: "130%",
                whiteSpace: "pre-wrap",
            },
            h5: {
                fontFamily: "Mark Pro, sans-serif",
                fontSize: 12,
                fontWeight: 500,
                lineHeight: "100%",
            },
            subtitle1: {
                fontFamily: "EnBW DIN Pro, sans-serif",
                fontSize: 12,
                fontWeight: 400,
                lineHeight: "130%",
                whiteSpace: "pre-wrap",
            },
            button: {
                [baseTheme.breakpoints.up("xsMobile")]: {
                    fontSize: 16,
                    fontFamily: "Mark Pro, sans-serif",
                    fontStyle: "normal !important",
                    fontWeight: 500,
                    lineHeight: "150%",
                    textTransform: "none",
                },
            },
        },
    });
};
